// src/features/auth/msal/msalAdapter.js
import { pca, SCOPES_ID, SCOPES_API, LOGIN_MODE } from "./msalClient";

const normalize = (acc) =>
  acc
    ? { name: acc.name, sub: acc.localAccountId, preferred_username: acc.username }
    : null;

export async function init() {
  await pca.initialize();
  try {
    const r = await pca.handleRedirectPromise();
    if (r?.account) pca.setActiveAccount(r.account);
  } catch {
    /* noop */
  }

  const acc = pca.getActiveAccount() || pca.getAllAccounts()[0] || null;
  if (!acc) return { user: null };

  if (SCOPES_API.length) {
    try {
      await pca.acquireTokenSilent({ account: acc, scopes: SCOPES_API });
    } catch {
      // sem interação, só seguimos — o getter tentará novamente
    }
  }
  return { user: normalize(acc) };
}

export async function login() {
  const request = { scopes: [...SCOPES_ID, ...SCOPES_API] };
  if (LOGIN_MODE === "popup") {
    try {
      const r = await pca.loginPopup(request);
      if (r?.account) pca.setActiveAccount(r.account);
      return;
    } catch {
      // fallback para redirect se popup for bloqueado
    }
  }
  await pca.loginRedirect(request);
}

export async function logout() {
  const account = pca.getActiveAccount() || pca.getAllAccounts()[0] || undefined;
  await pca.logoutRedirect({ account });
}

export async function getAccessToken() {
  const acc = pca.getActiveAccount() || pca.getAllAccounts()[0];
  if (!acc || !SCOPES_API.length) return null;

  try {
    const { accessToken } = await pca.acquireTokenSilent({ account: acc, scopes: SCOPES_API });
    return accessToken || null;
  } catch (e) {
    // Se precisar de interação (consent/reauth), abrimos login conforme modo
    const code = e?.errorCode || e?.name || "";
    const interactionNeeded =
      code.includes("interaction_required") ||
      code.includes("consent_required") ||
      code.includes("login_required");

    if (interactionNeeded) {
      await login();
      return null;
    }
    return null;
  }
}

export async function getIdTokenClaims() {
  const acc = pca.getActiveAccount() || pca.getAllAccounts()[0];
  if (!acc) return null;
  if (acc.idTokenClaims) return acc.idTokenClaims;

  try {
    const res = await pca.acquireTokenSilent({ account: acc, scopes: SCOPES_ID });
    return res?.idTokenClaims || null;
  } catch {
    return null;
  }
}
